"use strict";

module.exports = function (accumulator, order, product, component) {
  if (!component.name_printing && !component.guest_addressing && !component.return_addressing) {
    return accumulator;
  }

  var addition = component.print_flap_open ? 'PRINT FLAP OPEN' : 'PRINT FLAP CLOSED';

  if (accumulator.length && addition.length) {
    return "".concat(accumulator, "\n").concat(addition);
  }

  return addition;
};